import React, { useState, useEffect } from 'react';

import { useGetMuscleMass } from 'api/services';
import ChartModal from 'components/ChartModal/ChartModal';
import { chartsKey } from 'utils/constants';

import { getGradientBackground } from './utils/chartColorizing';
import {
	defaultChartAxisValues,
	handleChartData,
	getChartMaxValue,
	increaseOrDecreaseMaxYThreshold,
} from './utils/chartHelpers';
import { defaultConfig, styledChartElements } from './utils/customViewChart';

const MuscleMass = ({ closeChart, isOpen }) => {
	const [data, setData] = useState({});
	const [chartConfig, setChartConfig] = useState(null);
	const [labelsData, setLabelsData] = useState(undefined);

	const { data: muscleMassData, loading } = useGetMuscleMass();
	const isDataAvailable =
		muscleMassData?.data && muscleMassData.data.length > 0;

	useEffect(() => {
		if (isDataAvailable) {
			const dataAdapted = handleChartData(muscleMassData.data);

			setData(dataAdapted);
			setLabelsData(dataAdapted?.labels);
			handleChartConfig();
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [muscleMassData]);

	const handleChartConfig = () => {
		const minY = defaultChartAxisValues[chartsKey.muscleMass].minY;
		let maxY = defaultChartAxisValues[chartsKey.muscleMass].maxY;

		const maxValueOfY = getChartMaxValue(muscleMassData.data, 'value');

		if (maxValueOfY && maxValueOfY >= maxY) {
			maxY = maxValueOfY + increaseOrDecreaseMaxYThreshold.xl;
		}

		const config = {
			...defaultConfig,
			elements: styledChartElements(muscleMassData.data.length - 1),
			scales: {
				...defaultConfig.scales,
				y: {
					...defaultConfig.scales.y,
					min: minY,
					max: maxY,
				},
			},
		};

		setChartConfig(config);
	};

	const getChartData = (canvas) => {
		const gradient = getGradientBackground(canvas);

		return {
			...data,
			datasets: [
				{
					data: data?.datasets[0]?.data,
					fill: true,
					backgroundColor: gradient,
				},
			],
		};
	};

	return (
		<ChartModal
			loading={loading}
			labelsData={labelsData}
			data={getChartData}
			closeChart={closeChart}
			chartConfig={chartConfig}
			isOpen={isOpen}
		/>
	);
};

export default MuscleMass;
